import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRothkoFetcher } from "web/react/hooks/use-rothko-fetcher";
import {
    setRetailerInformation,
    setRetailerInformationLoading,
} from "web/redux/ducks/retailer-information";
import { ReduxStoreState } from "web/redux/store";
import { RetailerInformation } from "web/types/serializers";

function extractSelectedGender(state: ReduxStoreState): string {
    return state.mainNavigationReducer.selectedGender;
}

interface UseFetchRetailerInfoResults {
    fetchRetailerInfo: (retailerSlug: string) => Promise<void>;
}

export function useFetchRetailerInfo(): UseFetchRetailerInfoResults {
    const dispatch = useDispatch();
    const gender = useSelector(extractSelectedGender);

    const [fetch] = useRothkoFetcher<RetailerInformation>(
        "modules/retailer_information",
        undefined,
        true
    );

    const fetchRetailerInfo = useCallback(
        async function (retailerSlug: string): Promise<void> {
            dispatch(setRetailerInformationLoading(true));
            const retailerInformation = await fetch({ retailer_slug: retailerSlug, gender });

            if (retailerInformation) {
                dispatch(setRetailerInformation(retailerInformation));
            }
        },
        [dispatch, fetch, gender]
    );

    return { fetchRetailerInfo };
}
